import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router's client-side navigation doesn't auto-scroll to
// #anchors the way a full page load does. This fills that gap —
// used by pages that have footer/nav links pointing at an in-page
// section (e.g. /trusted-ecosystem#promise).
export function useScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    // Slight delay lets the page's own content render first.
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);
    return () => clearTimeout(timer);
  }, [hash]);
}
